export default {
  sections: [
  {
    "id": "business",
    "title": "Details of F-Gas Certified Business",
    "repeatable": false,
    "fields": [
      {
        "id": "businessName",
        "type": "text",
        "label": "Business Name",
        "required": true
      },
      {
        "id": "businessAddress",
        "type": "textarea",
        "label": "Business Address",
        "required": true
      },
      {
        "id": "businessTel",
        "type": "tel",
        "label": "Business Tel. No",
        "required": true
      }
    ]
  },
  {
    "id": "jobAddress",
    "title": "Job Address",
    "repeatable": false,
    "fields": [
      {
        "id": "jobName",
        "type": "text",
        "label": "Name",
        "required": true
      },
      {
        "id": "jobAddress",
        "type": "textarea",
        "label": "Address",
        "required": true
      },
      {
        "id": "jobTel",
        "type": "tel",
        "label": "Tel. No",
        "required": true
      },
      {
        "id": "accommodationRented",
        "type": "select",
        "label": "Is Accommodation Rented? (Y/N)",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      }
    ]
  },
  {
    "id": "landlordAgent",
    "title": "Landlord/Agent Address",
    "repeatable": false,
    "fields": [
      {
        "id": "landlordName",
        "type": "text",
        "label": "Name"
      },
      {
        "id": "landlordAddress",
        "type": "textarea",
        "label": "Address"
      },
      {
        "id": "landlordTel",
        "type": "tel",
        "label": "Tel. No"
      }
    ]
  },
  {
    "id": "heatPumpDetails",
    "title": "Heat Pump Details",
    "repeatable": false,
    "fields": [
      {
        "id": "unitMake",
        "type": "text",
        "label": "Unit Make",
        "required": true
      },
      {
        "id": "unitModel",
        "type": "text",
        "label": "Unit Model",
        "required": true
      },
      {
        "id": "serialNumber",
        "type": "text",
        "label": "Serial Number",
        "required": true
      },
      {
        "id": "mcsCertificationNumber",
        "type": "text",
        "label": "MCS Certification Number",
        "required": true
      },
      {
        "id": "installationDate",
        "type": "date",
        "label": "Installation Date",
        "required": true
      },
      {
        "id": "lastServiceDate",
        "type": "date",
        "label": "Last Service Date"
      }
    ]
  },
  {
    "id": "heatPumpInspection",
    "title": "Heat Pump Inspection Details",
    "repeatable": false,
    "fields": [
      {
        "id": "physicalDamage",
        "type": "select",
        "label": "Are there any signs of physical damage or obstructions?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "unitFreeOfLeaves",
        "type": "select",
        "label": "Is the unit free of leaves/debris?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "airFiltersCleaned",
        "type": "select",
        "label": "Have air filters (indoor units) been cleaned/replaced?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "evaporatorCoilsInspected",
        "type": "select",
        "label": "Have evaporator/condenser coils been inspected and cleaned?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "insulationIntact",
        "type": "select",
        "label": "Is the insulation around the refrigerant pipes intact and undamaged?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "electricalConnectionsSecure",
        "type": "select",
        "label": "Are electrical connections and components secure and undamaged?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "condensateDrainCleared",
        "type": "select",
        "label": "Has the condensate drain been cleared?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "fanBladesSmoothRunning",
        "type": "select",
        "label": "Are the fan, blades and motor running smoothly without abnormal sounds or vibrations?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "refrigerantLevelsAdhere",
        "type": "select",
        "label": "Do refrigerant levels adhere to F-Gas regulations?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "controllerInspected",
        "type": "select",
        "label": "Has the system's controller been inspected for any fault codes and reset if necessary?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "defrostSensorTested",
        "type": "select",
        "label": "Has the defrost sensor or timer been tested, ensuring proper cycle operation?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "temperatureDifferenceMeasured",
        "type": "select",
        "label": "Has the temperature difference between flow and return water been measured?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "waterPressureInRange",
        "type": "select",
        "label": "Is the water pressure in the heating loop within the manufacturer's recommended range?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "unitCheckedNoiseVibration",
        "type": "select",
        "label": "Has the unit been checked for abnormal noise/vibration?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      }
    ]
  },
  {
    "id": "hotWaterCylinderDetails",
    "title": "Hot Water Cylinder Details",
    "repeatable": false,
    "fields": [
      {
        "id": "cylinderMake",
        "type": "text",
        "label": "Cylinder Make",
        "required": true
      },
      {
        "id": "cylinderModel",
        "type": "text",
        "label": "Cylinder Model",
        "required": true
      },
      {
        "id": "cylinderSerialNumber",
        "type": "text",
        "label": "Serial Number",
        "required": true
      },
      {
        "id": "cylinderCapacity",
        "type": "number",
        "label": "Capacity (Litres)",
        "required": true
      },
      {
        "id": "cylinderInstallationDate",
        "type": "date",
        "label": "Installation Date",
        "required": true
      },
      {
        "id": "cylinderLastServiceDate",
        "type": "date",
        "label": "Last Service Date"
      }
    ]
  },
  {
    "id": "cylinderInspection",
    "title": "Heat Pump Inspection Details",
    "repeatable": false,
    "fields": [
      {
        "id": "cylinderPipeworkNoLeaks",
        "type": "select",
        "label": "Is the cylinder/pipework free from signs of leaks, rust or corrosion?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "pressureReliefValveFunctioning",
        "type": "select",
        "label": "Is the pressure relief valve functioning correctly and not leaking?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "temperaturePressureWithinLimits",
        "type": "select",
        "label": "Are the temperature and pressure settings within recommended limits?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "expansionVesselWithinSpecs",
        "type": "select",
        "label": "Is the expansion vessel's charge within manufacturer specifications?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "heatExchangerClean",
        "type": "select",
        "label": "Is the heat exchanger coil clean and free from build-up of scale?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "insulationJacketGood",
        "type": "select",
        "label": "Is the insulation jacket free of damage or wear and meets current building regulations?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "anodeFreeCorrosion",
        "type": "select",
        "label": "Is the anode free from corrosion?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "thermostatControllingTemp",
        "type": "select",
        "label": "Is the thermostat correctly controlling the water temperature?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "noErrorCodes",
        "type": "select",
        "label": "Are there error codes present on the cylinder's digital display? (if applicable)",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      },
      {
        "id": "cylinderDeliveringCorrectTemp",
        "type": "select",
        "label": "Is the cylinder delivering hot water at the correct temperature and flow rate?",
        "required": true,
        "options": [
          "Yes",
          "No"
        ]
      }
    ]
  },
  {
    "id": "defects",
    "title": "Defect(s) Identified",
    "repeatable": false,
    "fields": [
      {
        "id": "defectsIdentified",
        "type": "textarea",
        "label": "Defect(s) Identified"
      }
    ]
  },
  {
    "id": "workCarriedOut",
    "title": "Work Carried Out",
    "repeatable": false,
    "fields": [
      {
        "id": "workCarriedOut",
        "type": "textarea",
        "label": "Work Carried Out",
        "required": true
      }
    ]
  },
  {
    "id": "workRequired",
    "title": "Details Of Work Required",
    "repeatable": false,
    "fields": [
      {
        "id": "workRequired",
        "type": "textarea",
        "label": "Details Of Work Required"
      }
    ]
  },
  {
    "id": "receivedBy",
    "title": "Received By",
    "repeatable": false,
    "fields": [
      {
        "id": "receivedByName",
        "type": "text",
        "label": "Print Name",
        "required": true
      },
      {
        "id": "receivedByDate",
        "type": "date",
        "label": "Date",
        "required": true
      }
    ]
  },
  {
    "id": "issuedBy",
    "title": "Issued By",
    "repeatable": false,
    "fields": [
      {
        "id": "engineerSignature",
        "type": "signature",
        "label": "Signature",
        "required": true
      },
      {
        "id": "issuedByDate",
        "type": "date",
        "label": "Date",
        "required": true
      }
    ]
  },
  {
    "id": "nextService",
    "title": "Next Service Due",
    "repeatable": false,
    "fields": [
      {
        "id": "nextServiceDate",
        "type": "date",
        "label": "The next service is due",
        "required": true
      }
    ]
  }
]
};
